export function cloneObject<Type>(object: Type): Type {
  return JSON.parse(JSON.stringify(object));
}

export const sleep = (ms: number): Promise<number> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
